import { SET_THEME } from '../types';

export const setColorTheme = (theme) => ({
  type: SET_THEME,
  payload: theme,
});
